import angular from "angular";
import { AdpConfigListComponent } from "./adp-config-list.component";

export const AdpConfigListModule = angular
    .module('apex.adpConfig.list', [])
    .component("apexAdpConfigList", AdpConfigListComponent)
    .name;
